const ChristianFeeHeader = [
    { id: 1, label: "Total MBBS course fee", var: "coursefee" },
    { id: 2, label: "Total hostel fee for MBBS students", var: "hostelfee" },
];

export default ChristianFeeHeader;
